import { SummaryList } from 'nhsuk-react-components';

function RulesHeader() {
  return (
    <SummaryList.Row className="summary-table-header-row">
      <SummaryList.Value>
        <div className="rule-details">
          <div className="rule-priority">Priority</div>
          <div>Rule</div>
        </div>
      </SummaryList.Value>
      <SummaryList.Action>
        <div className="rules-header-action">Action</div>
      </SummaryList.Action>
    </SummaryList.Row>
  );
}

export default RulesHeader;
